import { memo } from "react"

import { Typography } from "@mui/material"

import { IContentItemsModalViewProps } from "src/modals/content-items/types/contentItemDetailModalView"

export const NavigationIDSection = memo(
    ({ id }: IContentItemsModalViewProps) => {
        return <Typography variant="subtitle2">{id ?? "-"}</Typography>
    },
)
